module.exports = __webpack_public_path__ + "static/img/1_3_2.b8e53338.jpg";